module.exports = __webpack_public_path__ + "static/media/dark_video.ade92daa.mp4";